import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en.json'; // Your English translations
import translationFR from './locales/fr.json'; // Your French translations
import translationAR from './locales/ar.json'; // Your Arabic translations

const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
  ar: { translation: translationAR },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr', // Default language
    interpolation: {
      escapeValue: false, // React already escapes variables
    },
  });

export default i18n;
